import $ from "jquery";
import React, { Suspense, useState } from 'react';


// Context

// Import
import ChangePassword from './ChangePassword';
import PersonalInformation from './PersonalInformation';
import ViewProfile from './ViewProfile';




export default function AccountSettings() {

    const [currentTab, setCurrentTab] = useState("view-profile");

    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }

    // const UserBasicInfoContextData = useContext(UserBasicInfoQRContext);


    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20">

            <div className="tab w-full">
                <button className="tablinks current" onClick={(event) => handleTab("view-profile", event)}>Company Information</button>
                <button className="tablinks " onClick={(event) => handleTab("personal-profile", event)}>Personal Information</button>
                <button className="tablinks" onClick={(event) => handleTab("change-password", event)}>Change Password</button>
            </div>

            <div className='tabcontentbody py-3'>
                <div id="view-profile" className="tabcontent" style={{ display: "block", paddingInline: "0px" }}>
                    <Suspense fallback="Loading...">


                        {(() => {
                            switch (currentTab) {
                                case "view-profile":
                                    return <ViewProfile></ViewProfile>
                                case "personal-profile":
                                    return <PersonalInformation></PersonalInformation>
                                case "change-password":
                                    return <ChangePassword></ChangePassword>
                                default:
                                    return <h1>No page found.</h1>
                            }
                        })()}



                    </Suspense>
                </div>
            </div>


        </div>
    )

}
